<ng-container *ngIf="operationalMessage$ | async as message">
  <py-alert-message
    [title]="message.headerMessage"
    [body]="message.bodyMessage"
    type="danger"
    [dismissable]="false"
  ></py-alert-message>
</ng-container>
